import './bookDemoFooter.scss';
import React from 'react';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
}

export const BookDemoFooter = (prop: IProp) => {
    if (prop.platform === 'twww') {
        return null;
    }
    return <div className="contract-sales-footer-bg"></div>;
};
